import styled from "styled-components";

export const Title = styled.p`
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-align: left;
  text-transform: uppercase;
`;

export const SearchButton = styled.button`
  font-size: 13px;
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  background: none;
  border: 0;
  cursor: pointer;
  font-weight: 900;
  line-height: 16px;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.default.color.primary};
  padding-left: 12px;
`;

export const SearchWrapper = styled.div`
  display: flex;
`;
